<template>
  <div class="game__advertising" v-if="advertising.length > 0">
    <div class="game__advertising__player">
      <template v-for="(video, idxVideo) in advertising">
        <video
          v-if="Number(idxVideo) == idxVideoReproduce" 
          :key="idxVideo" muted autoplay playsinline :ref="`video-${idxVideo}`" :src="video.url" @ended="endedVideo"
          poster="@/assets/superliga/ads-poster.jpg"></video>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    advertising: Array
  },
  data() {
    return {
      idxVideoReproduce: 0
    }
  },
  mounted() {
    this.reproduceVideo()
    document.addEventListener("resume", this.resumeVideo, false);
  },
  beforeDestroy() {
    document.removeEventListener("resume", this.resumeVideo, false);
  },
  methods: {
    endedVideo() {
      this.idxVideoReproduce += 1;
      if (this.advertising.length == this.idxVideoReproduce) {
        this.idxVideoReproduce = 0;
      }
      this.reproduceVideo(false)
    },
    resumeVideo (){
      this.reproduceVideo(true)
    },
    reproduceVideo(ignoreLoad) {
      const self = this;
      if (self.$route.name == 'ScreenGame') {
        var interval = setInterval(()=>{
          if(self.$refs[`video-${self.idxVideoReproduce}`] && self.$refs[`video-${self.idxVideoReproduce}`].length > 0)
          {
            if(!ignoreLoad) {
              self.$refs[`video-${self.idxVideoReproduce}`][0].load();
            }
            self.$refs[`video-${self.idxVideoReproduce}`][0].play();
            clearInterval(interval);
          }
        },100)
      }
    }
  },
  watch: {
    '$route'(value) {
      if (value.name == 'ScreenGame') this.resumeVideo()
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.game__advertising {
  margin: $margin-base;

  @media (min-width: $break-md) {
    max-width: 480px;
    width: 100%;
    position: absolute;
    right: 0;
    height: 270px;
    display: flex;
    justify-content: flex-end;
  }

  @media (min-width: $break-lg) {
    height: 364px;
    max-width: 640px;
  }

  &__player {
    border-radius: $margin-milli;
    width: 160px;
    left: 0;
    height: 90px;
    border: 2px solid $lightblue;
    position: relative;
    z-index: 2;
    box-shadow: $shadow;
    background: $lightblue;

    @media (min-height: 600px) {
      padding: 56.25% 0 0 0;
      width: 100%;
      height: auto;
      left: auto;
      bottom: auto;
      top: auto;
    }

    video {
      overflow: hidden;
      border-radius: $margin-milli;
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
      //background: #000;
    }

    .player {
      width: 100%;
    }
  }
}
</style>